import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogService } from 'src/app/core/dialog.service';
import { ErrorService } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { ScriptRunService } from 'src/app/core/script-run.service';
import { SCRIPT_RUN_SUCCESS_MESSAGE, SCRIPT_RUN_SUCCESS_TITLE } from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-scripts-form',
  templateUrl: './scripts-form.component.html',
  styleUrls: ['./scripts-form.component.scss'],
})
export class ScriptsFormComponent {
  scripts_form_group: FormGroup;
  error_matcher: FormErrorStateMatcher;

  is_script_create_running = false;

  file_name?: string;
  text_file?: string;

  constructor(
    private form_service: FormService,
    private script_run_service: ScriptRunService,
    private error_service: ErrorService,
    private dialog_service: DialogService,
  ) {
    this.scripts_form_group = this.form_service.scripts_form_group;
    this.error_matcher = this.form_service.matcher;
  }

  onRunClick(): void {
    if (this.isFormValid() && this.text_file && !this.is_script_create_running) {
      const script_type = this.scripts_form_group.get(this.form_service.script_type_label)?.value;
      this.createScriptRun(script_type, this.text_file);
    }
  }

  onFileLoaded(event: any): void {
    const file: File = event.target?.files[0];
    this.file_name = file.name;
    const reader = new FileReader();
    reader.onload = () => {
      this.text_file = reader.result as string;
    };
    reader.readAsText(file);
  }

  createScriptRun(script_type: string, text_file: string): void {
    this.is_script_create_running = true;
    this.script_run_service.create(script_type, text_file).subscribe({
      next: result => {
        this.dialog_service.openInfoDialog(SCRIPT_RUN_SUCCESS_MESSAGE, SCRIPT_RUN_SUCCESS_TITLE);
        this.is_script_create_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_script_create_running = false;
      },
    });
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.scripts_form_group);
  }

  isCsvUploadVisible(): boolean {
    const script_type = this.scripts_form_group.get(this.form_service.script_type_label)?.value;
    return [
      'update_prepaid_setting',
      'update_prepaid_long_setting',
      'update_fourthline_setting',
      'update_sdd_setting',
    ].includes(script_type);
  }
}
